import { Breadcrumb } from "antd";
import { useSelector } from "react-redux";
import breadList from "controllers/breadList";

function NavigationBar() {
  const menuList = useSelector((state) => state.etcReducer.breadCrumbList);

  breadList();
  return (
    <div style={{flex: "0 0 62px"}}>
      <Breadcrumb separator=">">
        {menuList.map((el, idx) => {
          return <Breadcrumb.Item key={idx}>{el}</Breadcrumb.Item>;
        })}
      </Breadcrumb>
      <div
        style={{
          display: "flex",
          height: "40px",
          fontSize: "20px",
          fontWeight: "500",
        }}
      >
        {menuList[menuList.length - 1]}
      </div>
    </div>
  );
}

export default NavigationBar;
